import {
  Box,
  Button,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Switch,
  Text,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { GetTeamsFunc } from "../Redux/Teams/getTeams";
import { MultiSelect } from "react-multi-select-component";
import { AssignFormFunc } from "../Redux/Form/AssignForm";
import { RecurringAssignFormFunc } from "../Redux/Form/RecurringAssign";

export const Assign = ({ FormId, isOpen, onClose }) => {
  const userId = useSelector((state) => state.user.userData.userId);
  const Id = useParams()
  const location = useLocation()
  const dispatch = useDispatch()
  const getTeamId = useSelector((state) => state.GetTeams.data)
  const toast = useToast()
  const [Selected, setSelected] = useState([])

  const [assignAt, setassignAt] = useState("")
  const [deadLine, setdeadLine] = useState("")
  const [ATime, setATime] = useState("")
  const [DTime, setDTime] = useState("")
  const navigate = useNavigate()
  const orgId = useSelector((state) => state.user.orgId);
  const [show,setShow]=useState(false)
  const [DailyAssign,setDailyAssign]=useState("")
  const [DAssign,setDAssign]=useState("")


  useEffect(() => {
    dispatch(GetTeamsFunc(userId))
  }, [userId])


  const handleAssignAt = (e) => {
    setATime(e.target.value)
    const dateInMilliseconds = new Date(e.target.value).getTime();
    setassignAt(dateInMilliseconds)
  }

  const handleDeadline = (e) => {
    setDTime(e.target.value)
    const dateInMilliseconds = new Date(e.target.value).getTime();
    setdeadLine(dateInMilliseconds)

  }

  const handleDailyAssign=(e)=>{
    setDAssign(e.target.value)
    setDailyAssign(e.target.value)

  }


console.log(show)

  const handleAssignClick = () => {
    const createpost = { teamIds: Selected.map((el) => el.value), assignAt, deadLine }

    if(show==true){
      dispatch(RecurringAssignFormFunc(createpost,DailyAssign,Id.formId,userId)).then((res)=>{
        
        console.log(res)
        if (res.type === "RecurringAssignSlice/RecurringAssignSuccess") {

          toast({
            title: `Assign Form Succesfully`,
            status: "success",
            position: "top",
            duration: 2000,
            isClosable: true,
          })
    onClose()
    navigate(`/myforms?orgId=${orgId}`)

        }

      })
    }
    else{

      
    if (location.pathname === `/${Id.formId}/viewform`) {
      dispatch(AssignFormFunc(createpost, Id.formId, userId)).then((res) => {

        onClose()
        if (res.type === "AssignSlice/AssignSuccess") {

          toast({
            title: `Assign Form Succesfully`,
            status: "success",
            position: "top",
            duration: 2000,
            isClosable: true,
          })

          navigate(`/myforms?orgId=${orgId}`)

        }
      })
    }
    else {
      dispatch(AssignFormFunc(createpost, FormId, userId)).then((res) => {

        onClose()
        if (res.type === "AssignSlice/AssignSuccess") {

          toast({
            title: `Assign Form Succesfully`,
            status: "success",
            position: "top",
            duration: 2000,
            isClosable: true,
          })



        }
      })
    }

    }


    setATime("")
    setDTime("")



  }


  return (
    <div>
      <Modal blockScrollOnMount={false} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Assign Form</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Box
              display={"grid"}
              gridTemplateColumns="1"
              alignItems="center"
              gap="3"
            >
              <Text>Teams</Text>
              <MultiSelect
                options={getTeamId.map((e) => ({ label: e.teamName, value: e.teamId }))}
                value={Selected}
                onChange={setSelected}
                labelledBy="Select"
              />

              <Box display="flex" justifyContent={"space-between"} alignItems={"center"}>
                <Text>Enable Recurring</Text>
                <Switch onChange={()=>setShow(!show)}  />
              </Box>
              {
                show?<Input type="time" onChange={handleDailyAssign} value={DAssign}/>:<Box>  <Text>Assign At</Text>
                <Input type="datetime-local" onChange={handleAssignAt} value={ATime} />
                </Box>
              }
              <Text>Deadline</Text>
                <Input type="datetime-local" onChange={handleDeadline} value={DTime} />
            
            </Box>
          </ModalBody>

          <ModalFooter>
            <Button mr="3" colorScheme="blue" onClick={handleAssignClick}>
              Assign
            </Button>
            <Button colorScheme="red" mr={3} onClick={onClose}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};
